

<script>
import { Bar } from 'vue-chartjs'
export default {
    extends: Bar,
    props: ['chartData', 'scheme'],
    data() {
        return {
            data: {},
            schemes: {
                Grid6: ['#c66951', '#bf974d', '#928b70', '#87706b', '#94734e', '#6f777d'],
                HueCircle19: ['#1ba3c6', '#2cb5c0', '#30bcad', '#21B087', '#33a65c', '#57a337', '#a2b627', '#d5bb21', '#f8b620', '#f89217', '#f06719', '#e03426', '#f64971', '#fc719e', '#eb73b3', '#ce69be', '#a26dc2', '#7873c0', '#4f7cba'],
                Temperature7: ['#529985', '#6c9e6e', '#99b059', '#dbcf47', '#ebc24b', '#e3a14f', '#c26b51'],
                Blue20: ['#b9ddf1', '#afd6ed', '#a5cfe9', '#9bc7e4', '#92c0df', '#89b8da', '#80b0d5', '#79aacf', '#72a3c9', '#6a9bc3', '#6394be', '#5b8cb8', '#5485b2', '#4e7fac', '#4878a6', '#437a9f', '#3d6a98', '#376491', '#305d8a', '#2a5783'],
                modern: ['#003f5c', '#2f4b7c', ' #665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600'],
                base: ['#39afd1', '#edf2f9', '#12263f', '#d5e5fa', '#d7eff6', '#fdf3d9', '#fad7dd', '#d0d4d9']
            },

        }
    },
    mounted() {
        this.prepare(this.chartData);
        this.render();
    },
    watch: {
        chartData(newValue) {

            this.prepare(newValue);
            this.render();

        }
    },
    methods: {
        prepare(values) {
            this.data = {
                labels: [],
                datasets: [
                    {
                        data: []
                    }
                ]
            };

            values.forEach(element => {
                this.data.labels.push(element._id);
                this.data.datasets[0].data.push(element.count);
            });

            this.data.datasets.map(item => {
                item.backgroundColor = this.schemes[this.scheme];
            });
        },
        render() {
            this.renderChart(
                this.data,
                {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false,
                        position: 'top',
                        fullWidth: true,
                        usePointStyle: true,
                    },
                }
            )
        }
    }
}
</script>
